import { useEffect, useState } from "react";
import {
  Autocomplete,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import StoAIRecomondation from "./StoAiRecomondation";
import { useSTOAIRecommendations } from "../../../../STOperationhooks/useSTOOperationAI";
import SearchTermTabskeleton from "../../../../SearchTermSkeletons/SearchTermTabskeleton";
import { Stack } from "@mui/system";

export default function STO_AI_Rec_Scope_Selection() {
  const [value, setValue] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { fetchAIRecommendations, getAllSTLevel } = useSTOAIRecommendations();
  const { scopesOfSTOperation } = useSelector(
    (state: any) => state.searchTermOperation
  );
  const { allAIRecomendation, loadingAiRecomendationInner } = useSelector(
    (state: any) => state.aiRecomandationTab
  );

  useEffect(() => {
    const scopeUid = searchParams.get("scopeUid");
    if (!scopeUid || !scopesOfSTOperation.length) return;

    const match = scopesOfSTOperation.find(
      (s: any) => s.shared_uid === scopeUid
    );

    if (match) {
      setValue(match);
    }
  }, [searchParams, scopesOfSTOperation]);

  const handleSelect = (selected: any) => {
    setValue(selected);

    const params = new URLSearchParams(searchParams);

    if (!selected) {
      params.delete("scopeUid");
      setSearchParams(params);
      return;
    }

    const uid = selected.shared_uid;
    params.set("scopeUid", uid);
    setSearchParams(params);

    fetchAIRecommendations(uid);
    getAllSTLevel(uid);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
        sx={{ marginInline: 3 }}
      >
        {/* LEFT SIDE — TITLE + DESCRIPTION */}
        <Stack direction="column" spacing={0.5}>
          <Typography variant="h5">Suggestions</Typography>
          <Typography variant="body2" gutterBottom color="text.secondary">
            Identify negative search terms that likely shouldn't be classified
            as such, by recognizing very similar search terms already defined as
            “Exclusive” or “Allowed” in other ad groups.
          </Typography>
        </Stack>

        {/* RIGHT SIDE — AUTOCOMPLETE */}
        <Autocomplete
          options={scopesOfSTOperation || []}
          getOptionLabel={(option: any) => option.name}
          value={value}
          onChange={(_, newValue) => handleSelect(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Scope"
              size="small"
              color="secondary"
            />
          )}
          sx={{ width: 220 }} // keep a fixed width like screenshot
        />
      </Stack>

      {loadingAiRecomendationInner ? (
        <SearchTermTabskeleton />
      ) : value && allAIRecomendation ? (
        allAIRecomendation.length > 0 ? (
          <StoAIRecomondation />
        ) : (
          <TableContainer component={Paper} sx={{ boxShadow: "none", mt: 2 }}>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={10} // adjust to match your column count
                    sx={{
                      py: 3,
                      color: "text.secondary",
                      fontSize: "0.9rem",
                    }}
                  >
                    No data available
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )
      ) : null}
    </>
  );
}
